import { useEffect, useState } from "react";
import axios from "../api/axios";
import { useQueryClient } from "@tanstack/react-query";
import { clearDisclaimer } from "../services/teleconsultationDisclaimerService";
import { useCheckoutStore } from "../stores/checkoutStore";

export const usePayment = ({ authToken, navigate }: any) => {
  const queryClient = useQueryClient();
  const [creatingRequest, setCreatingRequest] = useState(false);
  const [paying, setPaying] = useState(false);

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) setPaying(false);
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  // STEP 1 — dipanggil dari Disclaimer
  const createConsultationRequest = async (payload: any) => {
    setCreatingRequest(true);
    try {
        const res = await axios.post(
            "/teleconsult/create-request",
            payload,
            {
            headers: { Authorization: `Bearer ${authToken}` },
            }
        );

      queryClient.invalidateQueries({ queryKey: ["home"] });
      useCheckoutStore.getState().resetCheckout();
      return res.data; // { teleconsultId, encToken }
    } finally {
      setCreatingRequest(false);
    }
  };

  const validateCheckout = async (teleconsultId: string, payload: any) => {    
    const res = await axios.post(`/teleconsult/checkout-info`, payload, {
      headers: { Authorization: `Bearer ${authToken}` },
    });
    return res.data;
  };

  // STEP 2 — dipanggil dari Checkout, setelah dokter accept
  const createPayment = async ({ teleconsultId, payload, checkoutInfo, onVoucherChanged }: any) => {    
    setPaying(true);
    try {
      const latest = await validateCheckout(teleconsultId, payload);
      if (latest.discount !== checkoutInfo?.discount) {
        onVoucherChanged(latest);
        setPaying(false);
        return;
      }

      const res = await axios.post(`/teleconsult/${teleconsultId}/pay`, payload, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      if (res.data.paymentUrl) {
        queryClient.invalidateQueries({ queryKey: ["checkout-info"] });
        sessionStorage.setItem('pending_checkout_id', teleconsultId);
        window.location.href = res.data.paymentUrl;
        return;
      }

      useCheckoutStore.getState().resetCheckout();
      const encToken = res.data.encToken || localStorage.getItem(`teleconsult_token_${teleconsultId}`) || '';
      if (res.data.encToken) {
        localStorage.setItem(`teleconsult_token_${teleconsultId}`, res.data.encToken);
      }
      navigate(`/connect-doctor/${teleconsultId}/${encToken}?stage=final-confirm`, { replace: true });
    } catch (err) {
      setPaying(false);
      throw err;
    }
  };

  return { creatingRequest, paying, createConsultationRequest, createPayment };
};